<template>
  <CronTriggerList></CronTriggerList>
</template>

<script>
  import CronTriggerList from '../components/CronTriggerList';

  export default {
    name: "CronTriggerView",

    components: {
      CronTriggerList
    }
  }
</script>

<style scoped>

</style>
